import React, { Component } from 'react';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import PrivateRoute from './PrivateRoute'

//import Homepage from './Homepage'
import Header from './Components/fna/Header';
import Login from './Components/fna/Login';
import LoginSplash from './Components/fna/LoginSplash';
import ForgotPassword from './Components/fna/ForgotPassword';
import ResetPassword from './Components/fna/ResetPassword';
import ExhibitorDetails from './Components/fna/Exhibitor/ExhibitorDetails';
import ExhibitorBooth from './Components/fna/Exhibitor/ExhibitorBooth';

import Dashboard from './Components/fna/Exhibitor/Dashboard';
import Lobby from './Components/fna/Attendee/Lobby';
import ExhibitHall from './Components/fna/Attendee/ExhibitHall';
import NetworkingLounge from './Components/fna/Attendee/NetworkingLounge';
import ConferenceCenter from './Components/fna/Attendee/ConferenceCenter';
import ConferenceCenterPage from './Components/fna/Attendee/ConferenceCenterPage';
import TechnicalSessions from './Components/fna/Attendee/TechnicalSessions';

import HelpDesk from './Components/fna/Attendee/HelpDesk';
import AttendeeExhibitorBooth from './Components/fna/Attendee/AttendeeExhibitorBooth';
import NotFound from './Components/fna/NotFound';

import DashboardSpeaker from './Components/fna/Speaker/Dashboard';
import ProfileDetails from './Components/fna/Speaker/ProfileDetails';
//import SpeakerSession from './Components/fna/Speaker/SpeakerSession';
import SessionAttendees from './Components/fna/Speaker/SessionAtendees';

import ChatPage from "./TmChat/fna/chat/ChatPage";
import VideoCall from "./TmChat/fna/video/VideoCall";
import ConferenceMeeting from "./TmChat/fna/videoConference/conferenceMeeting";
import Meetings from "./TmChat/fna/videoConference/meetings";
import UserProfile from './Components/fna/UserProfile';

import WorkProgress from './Components/fna/WorkProgress';
import speakerWebinar from "./TmChat/fna/speakerWebinar/speakerWebinar";

import Disabled from './Components/Disabled';

/* import test from './Components/fna/Exhibitor/test'; */

class Fna extends Component {
// constructor(){
//   super();

//   this.state={
//     homePage:""
//   }
// }
componentDidMount(){
  //console.log(window.location.href)
  
}

  render() {


      return (
      <Router>
          <div className="App">
            <Header/>
            <Switch>
                <Route path="/fna/login/:loginId" exact component={Login} />
                <PrivateRoute path="/fna/loginSplash" exact component={LoginSplash} />
                <Route path="/fna/forgotPassword" component={ForgotPassword} />
                <Route path="/fna/resetPassword" component={ResetPassword} />
                <Route path="/fna/disabled" component={Disabled} />
                <PrivateRoute path="/fna/chat" exact component={ChatPage} />
                <PrivateRoute path="/fna/video-call" exact component={VideoCall} />
                <PrivateRoute path="/fna/video-conference" exact component={Meetings} />
                <PrivateRoute path="/fna/conference-meeting/:id" exact component={ConferenceMeeting} />
                <PrivateRoute path="/fna/exhibitor/dashboard" exact component={Dashboard} />
                <PrivateRoute path="/fna/exhibitor/profile" exact component={ExhibitorDetails} />
                <PrivateRoute path="/fna/exhibitor/booth" component={ExhibitorBooth} />
                <PrivateRoute path="/fna/attendee/lobby" component={Lobby} />
                <PrivateRoute path="/fna/attendee/exhibitHall" component={ExhibitHall} />
                <PrivateRoute path="/fna/attendee/networkingLounge" component={NetworkingLounge} />
                <PrivateRoute path="/fna/attendee/conferenceCenter" component={ConferenceCenter} />
                <PrivateRoute path="/fna/attendee/conferenceCenterDetails/:sessionId" component={ConferenceCenterPage} />
                <PrivateRoute path="/fna/attendee/technicalSessions" component={TechnicalSessions} />
                <PrivateRoute path="/fna/attendee/helpDesk" component={HelpDesk} />
                <PrivateRoute path="/fna/attendee/exhibitorBooth/:exhibitorId" component={AttendeeExhibitorBooth} />
                <PrivateRoute path="/fna/speaker/dashboard" exact component={DashboardSpeaker} />
                <PrivateRoute path="/fna/speaker/profile" exact component={ProfileDetails} />
                <PrivateRoute path="/fna/speaker/attendees" exact component={SessionAttendees} />
                <PrivateRoute path="/fna/user/profile" exact component={UserProfile} />
                <Route path="/fna/workProgress" exact component={WorkProgress} />
                <PrivateRoute path="/fna/speaker/session/:sessionId" exact component={speakerWebinar} />
                <Route path="*" component={NotFound} />
              </Switch>
         
          </div>
      </Router>
    );
  }  
}

export default Fna;
